import  { lazy } from 'react';
import Auth from '../../hoc/Auth';

const loadMoneyPromise = import("./LoadMoney.js")
const loadPaymentPromise = import("./LoadMoneyPayment.js")
const walletPromise = import("./Wallet.js")
const withdrawPromise = import("./Withdraw.js")

export const LoadMoney = Auth(lazy(() => loadMoneyPromise));
export const LoadMoneyPayment = Auth(lazy(() => loadPaymentPromise));
export const Wallet = Auth(lazy(() => walletPromise));
export const Withdraw = Auth(lazy(() => withdrawPromise));